import { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import { myApi } from '../../../config/axiosConfig';

const numero = (valor, porcentaje = false) => {
    if (valor === null || valor === undefined || valor === '') {
        return 'N/D';
    }

    const n = Number(valor);
    if (!Number.isFinite(n)) return 'N/D';

    const texto = n.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return porcentaje ? `${texto} %` : texto;
};

export default function DetalleResetSamsara({ resetId, onClose }) {
    const [resultado, setResultado] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let vigente = true;

        const cargar = async () => {
            setLoading(true);
            setResultado(null);
            setError('');

            try {
                const { data } = await myApi.post(
                    '/samsara/resets/detalle',
                    { resetId },
                    { timeout: 60000 }
                );

                if (data?.success !== true || !Array.isArray(data.rows)) {
                    throw new Error('Respuesta inesperada.');
                }

                if (vigente) setResultado(data);

            } catch (err) {
                if (vigente) {
                    const mensaje = err.response?.data?.error;

                    setError(
                        typeof mensaje === 'string'
                            ? mensaje
                            : 'No se pudo consultar el detalle.'
                    );
                }
            } finally {
                if (vigente) setLoading(false);
            }
        };

        cargar();

        return () => {
            vigente = false;
        };
    }, [resetId]);

    return (
        <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Detalle del reset #{resetId}</DialogTitle>

            <DialogContent>
                {loading && (
                    <Typography>Consultando periodo…</Typography>
                )}

                {error && <Alert severity="error">{error}</Alert>}

                {resultado && (
                    <>
                        <Typography sx={{ mb: 1 }}>
                            {resultado.reset?.driver}
                        </Typography>

                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Fecha del reset: {resultado.reset?.fecha_reset}
                        </Typography>

                        {resultado.periodo && (
                            <Alert severity="info" sx={{ mb: 2 }}>
                                Desde {resultado.periodo.desde} hasta{' '}
                                {resultado.periodo.hasta_exclusivo},
                                sin incluir este último día.
                                Omnitracs aporta fechas anteriores al
                                1 de agosto de 2026 y Samsara desde esa fecha.
                            </Alert>
                        )}

                        {(resultado.avisos || []).map((aviso, indice) => (
                            <Alert
                                key={indice}
                                severity={
                                    resultado.estado === 'INICIAL'
                                        ? 'info'
                                        : 'warning'
                                }
                                sx={{ mb: 1 }}
                            >
                                {aviso}
                            </Alert>
                        ))}

                        {resultado.rows.length > 0 && (
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Fuente</TableCell>
                                            <TableCell align="right">Millas</TableCell>
                                            <TableCell align="right">Galones US</TableCell>
                                            <TableCell align="right">MPG</TableCell>
                                            <TableCell align="right">Idle</TableCell>
                                            <TableCell align="right">Cruise</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {resultado.rows.map(fila => (
                                            <TableRow
                                                key={fila.fuente}
                                                sx={
                                                    fila.fuente === 'TOTAL COMBINADO'
                                                        ? {
                                                            backgroundColor: '#eef4ff',
                                                            '& td': { fontWeight: 700 }
                                                        }
                                                        : {}
                                                }
                                            >
                                                <TableCell>{fila.fuente}</TableCell>
                                                <TableCell align="right">
                                                    {numero(fila.millas)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {numero(fila.galones_us)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {numero(fila.mpg)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {numero(fila.idle_porcentaje, true)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {numero(fila.cruise_porcentaje, true)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
}